import React from "react";
import BreadcrumbSeven from "../components/BreadcrumbSeven";
import Blog from "../components/Blog";
import BrandSectionOne from "../components/BrandSectionOne";
import Preloader from "../helper/Preloader";
const BlogPage = () => {

  return (
    <>
    {/* Preloader */}
      <Preloader />

      {/* BreadcrumbSeven */}
      <BreadcrumbSeven />

      {/* Blog */}
      <Blog />

      {/* BrandSectionOne */}
      <BrandSectionOne />

    </>
  );
};

export default BlogPage;
